/** Display order for project role dropdowns (e.g. invite user panel). */
export const PROJECT_ROLE_DISPLAY_ORDER: string[] = [
  "gc_project_admin",
  "gc_estimator",
  "gc_foreman",
  "gc_sc_architect",
  "gc_sc_design_engineer",
  "gc_sc_owner",
  "gc_sc_project_admin",
  "gc_sc_foreman",
  "sc_project_admin",
  "sc_foreman",
  "architect",
  "design_engineer",
  "owner"
];
